import React, { useEffect, useState } from "react";

import { useHistory, useLocation } from "react-router-dom";

import { Box, Button, Menu, MenuItem, makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

import { useApp } from "@ip-contexts/app-context";
import { useUser } from "@ip-contexts/user-context";

import routes from "../../Routes";

const useStyles = makeStyles((theme) => ({
  department: {
    backgroundColor: theme.palette.common.white05,
    color: theme.palette.common.white,
    padding: "5px 5px 5px 10px",
    "&:hover": {
      backgroundColor: theme.palette.common.white10,
    },
  },
}));

export default function Department() {
  const [anchor, setAnchor] = React.useState(null);
  const [current, setCurrent] = useState(null);
  const [items, setItems] = useState([]);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const {
    state: { user },
  } = useUser();
  const {
    state: { department },
  } = useApp();

  const currentDepartmentPath = `/${department}`;

  function handleOpen(e) {
    setAnchor(e.currentTarget);
  }

  function handleClose() {
    setAnchor(null);
  }

  function handleClick(item) {
    handleClose();

    if (item.path.includes(currentDepartmentPath)) {
      history.go(0);
    } else {
      history.push(item.path);
    }
  }

  useEffect(() => {
    const filterDepartment = (audiences, department) => {
      if (department.roles) {
        const res = department.roles[audiences]?.some((scope) =>
          user.roles[audiences]?.includes(scope)
        );
        if (res) {
          return true;
        }
      }
      return false;
    };

    const items = routes.filter((department) => {
      if (department.hidden) {
        return false;
      }

      for (const key in department.roles) {
        if (!filterDepartment(key, department)) {
          return false;
        }
      }
      return true;
    });

    setItems(items);
  }, [user]);

  useEffect(() => {
    if (items.length) {
      const item = items.find((item) => item.path === currentDepartmentPath);
      if (item) {
        setCurrent(item);
      }
    }
  }, [history, items, location, currentDepartmentPath]);

  const renderItems = () => {
    return items.map((item, key) => (
      <MenuItem
        key={key}
        selected={current && current.name === item.name}
        onClick={() => handleClick(item)}
      >
        {item.name}
      </MenuItem>
    ));
  };

  return (
    items.length > 1 && (
      <React.Fragment>
        <Button className={classes.department} onClick={handleOpen}>
          <Box component="span" marginRight="auto">
            {current && current.name}
          </Box>
          {anchor ? (
            <ExpandLess fontSize="small" />
          ) : (
            <ExpandMore fontSize="small" />
          )}
        </Button>
        <Menu
          anchorEl={anchor}
          keepMounted
          open={!!anchor}
          onClose={handleClose}
        >
          {renderItems()}
        </Menu>
      </React.Fragment>
    )
  );
}
